/* eslint-disable */

import States from './states';
import Mediator from '@/scripts/stage/globals/mediator';

import {
  SET_CONTAINER,
  SET_IS_SPECULAR,
  IS_SPECULAR,
  SET_ROTA_X,
  SET_ROTA_Y,
  SET_ROTA_Z,
  ROTA_X,
  ROTA_Y,
  ROTA_Z,
  SET_IS_LIGHT_RTN,
} from '@/scripts/stage/constants';

import Shared from '@/scripts/stage/shared/index';


export default class WebglApp {
  constructor(options) {
    if (options.container) {
      SET_CONTAINER(options.container);
    } else {
      console.error('no container specified');
    }

    if (options.isSpecularLighting) {
      SET_IS_SPECULAR(options.isSpecularLighting);
    }

    if (options.isLightRotating) {
      SET_IS_LIGHT_RTN(options.isLightRotating);
    }


    this.data = {};
  }

  resize(w, h) {
    Mediator.resize(w, h);
  }


  load() {
    return this.preload();
  }

  start() {
    States.start();
  }

  preload() {
    return new Promise((resolve) => {
      resolve();
    });
  }

  play() {
    Mediator.play();
  }

  pause() {
    Mediator.pause();
  }

  set organicity(val) {
    States.world3D.blob.material.setOrganicity(val);
  }

  get organicity() {
    return States.world3D.blob.material.organicity.value;
  }

  set offsetY(val) {
    States.world3D.camera.setOffset(val);
  }

  get offsetY() {
    return States.world3D.camera._offsetY;
  }

  set depth(val) {
    States.world3D.camera.position.z = val;
  }

  get depth() {
    return States.world3D.camera.position.z;
  }

  set scale(val) {
    States.world3D.blob.scale.x = val;
    States.world3D.blob.scale.y = val;
    States.world3D.blob.scale.z = val;
  }

  get scale() {
    return States.world3D.blob.scale;
  }

  set morph(val) {
    States.world3D.blob.material.uniforms.shapeRatio.value = val;
  }

  get morph() {
    return States.world3D.blob.material.uniforms.shapeRatio.value;
  }


  set fogNear(val) {
    States.world3D.blob.material.uniforms.fogNear.value = val;
  }


  get fogNear() {
    return States.world3D.blob.material.uniforms.fogNear.value;
  }

  set fogFar(val) {
    States.world3D.blob.material.uniforms.fogFar.value = val;
  }

  get fogFar() {
    return States.world3D.blob.material.uniforms.fogFar.value;
  }

  set fogColor(val) {
    Shared.fogColor.value.setHex(val);

    Shared.opts.fogColor = `#${val.toString(16)}`;
  }

  get fogColor() {
    return Shared.fogColor.value;
  }

  set objColor(val) {
    Shared.objColor.value.setHex(val);

    Shared.opts.objColor = `#${val.toString(16)}`;
  }

  get objColor() {
    return Shared.objColor.value;
  }

  set hemi_ground(val) {
    Shared.hemi_ground.value.setHex(val);

    Shared.opts.hemi_ground = `#${this.decimalToHex(val, 6)}`;
  }

  get hemi_ground() {
    return Shared.hemi_ground.value;
  }

  set hemi_color_1(val) {
    Shared.hemi_color_1.value.setHex(val);

    Shared.opts.hemi_color_1 = `#${this.decimalToHex(val, 6)}`;
  }

  get hemi_color_1() {
    return Shared.hemi_color_1.value;
  }

  set hemi_color_2(val) {
    Shared.hemi_color_2.value.setHex(val);

    Shared.opts.hemi_color_2 = `#${this.decimalToHex(val, 6)}`;
  }

  get hemi_color_2() {
    return Shared.hemi_color_3.value;
  }

  set hemi_color_3(val) {
    Shared.hemi_color_3.value.setHex(val);

    Shared.opts.hemi_color_3 = `#${this.decimalToHex(val, 6)}`;
  }

  get hemi_color_3() {
    return Shared.hemi_color_3.value;
  }

  set shininess(val) {
    if (IS_SPECULAR) {
      States.world3D.blob.material.uniforms.shininess.value;
    } else {
      console.warn('isnt specular');
    }
  }

  set specularity(val) {
    if (IS_SPECULAR) {
      States.world3D.blob.material.uniforms.specularity.value;
    } else {
      console.warn('isnt specular');
    }
  }

  set specpower(val) {
    if (IS_SPECULAR) {
      States.world3D.blob.material.uniforms.surface.value;
    } else {
      console.warn('isnt specular');
    }
  }

  get shininess() {
    return States.world3D.blob.material.uniforms.shininess.value;
  }

  get specularity() {
    return States.world3D.blob.material.uniforms.specularity.value;
  }

  get specpower() {
    return States.world3D.blob.material.uniforms.surface.value;
  }

  set shapeA(val) {
    States.world3D.blob.material.uniforms.shape.value.x = val;
  }

  get shapeA() {
    return States.world3D.blob.material.uniforms.shape.value.x;
  }

  set shapeN(val) {
    States.world3D.blob.material.uniforms.shape.value.y = val;
  }

  get shapeN() {
    return States.world3D.blob.material.uniforms.shape.value.y;
  }

  set shapeM(val) {
    States.world3D.blob.material.uniforms.shape.value.z = val;
  }

  get shapeM() {
    return States.world3D.blob.material.uniforms.shape.value.z;
  }


  set rota_x(val) {
    States.world3D.opts.rota_x = val;

    SET_ROTA_X(val);
  }

  get rota_x() {
    return ROTA_X;
  }

  set rota_y(val) {
    States.world3D.opts.rota_y = val;

    SET_ROTA_Y(val);
  }

  get rota_y() {
    return ROTA_Y;
  }

  set rota_z(val) {
    States.world3D.opts.rota_z = val;

    SET_ROTA_Z(val);
  }

  get rota_z() {
    return ROTA_Z;
  }

  set layerPower(val) {
    States.world3D.blob.material.uniforms.layerPower.value = val;
  }

  get layerPower() {
    return States.world3D.blob.material.uniforms.layerPower.value;
  }

  decimalToHex(decimal, chars) {
    return (decimal + Math.pow(16, chars)).toString(16).slice(-chars).toUpperCase();
  }
}
